import React from "react";
import '../styles/TextPage.css';
import { useTranslation } from "react-i18next";

const CookiePolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="main-content">
      <div className="PrivacyInfo">
        <span className="InfoHeader">{t('cookiePolicy.title')}</span>
        <span className="PrivacyInfo__title">{t('cookiePolicy.section1Title')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section1Desc')}</span>
        <span className="PrivacyInfo__title">{t('cookiePolicy.section2Title')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section2Desc')}</span>
        <span className="PrivacyInfo__title">{t('cookiePolicy.section3Title')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section3Desc')}</span>
        <span className="PrivacyInfo__title">{t('cookiePolicy.section4Title')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section4Desc1')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section4Desc2')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section4Desc3')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section4Desc4')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section4Desc5')}</span>
        <span className="PrivacyInfo__title">{t('cookiePolicy.section5Title')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section5Desc1')}</span>
        <span className="PrivacyInfo__description">{t('cookiePolicy.section5Desc2')}</span>
        <span className="PrivacyInfo_description">{t('cookiePolicy.section5Desc3')}</span>
      </div>
    </div>
  );
};

export default CookiePolicy;